export default "__VITE_ASSET__DzJXSIyE__"